import { User } from './../objects/real-time';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import { Http , Response,Headers, RequestOptions} from '@angular/http';
import {Vehicule} from '../objects/index';
import {Driver} from '../objects/index';
import {GlobalService} from "./global.config";
import {Events } from 'ionic-angular';

@Injectable()
export class DriverService {
dns:string;
   constructor(private _http: Http,private globalService : GlobalService,public events: Events) {
       this.currentuser=JSON.parse(localStorage.getItem('currentuser'));
       this.dns = globalService.getDns();
        console.log(this.dns);
    }
currentuser:User;
public toastyAdd:Boolean=false;
public toastyUpdate:Boolean=false;
public drivers:Driver[]=[];
public bigCurrentPage:number = 1;

 
    getDriversByPageAndSize(page:number,size:number): Observable<any> {
              let headers = new Headers({'Accept': 'application/json'});
              headers.append('Authorization', this.currentuser.token);
              return this._http.get(this.dns + 'drivers/'+'list'+'?page='+page+'&size='+size, {headers: headers}).map(res => res.json());
    }


    deleteDriverById(id:number): Observable<Boolean> {
              let headers = new Headers({'Accept': 'application/json'});
              headers.append('Authorization', this.currentuser.token);
        return this._http.delete(this.dns + 'drivers/'+id, {headers: headers}).map(res => res.json());
    }
     
    public putDriver(driver:Driver): Observable<Driver> {
            let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Accept', 'application/json');
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(driver);
    return this._http.put(this.dns + 'drivers/',driver, options).map(res => res.json());
    }   

   public addDriver(driver:Driver): Observable<Driver> {
            let headers = new Headers({'Content-Type': 'application/json'});
        headers.append('Accept', 'application/json');
        headers.append('Authorization', this.currentuser.token);
        let options = new RequestOptions({headers: headers});
        let body = JSON.stringify(driver);
    return this._http.post(this.dns + 'drivers/',driver, options).map(res => res.json());
   }

   getDriver(idDriver: number){
   return this.drivers.find(driver => driver.idDriver === idDriver);
   }

    getOne(idDriver:number): Observable<Driver> {
              let headers = new Headers({'Accept': 'application/json'});
              headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'drivers/'+idDriver, {headers: headers}).map(res => res.json());
    }

}





// WEBPACK FOOTER //
// ./src/providers/driver.service.ts